<template>
  <div id="dcdcDetail">
    <!-- 设备基本信息 -->
    <el-row>
      <div class="headTitle">
        <span style="font-size: 20px;margin-right: 20px;">{{ basicinfo.deviceName }}</span>
        <span style="font-size: 18px;margin-right: 20px;">({{ basicinfo.deviceSn }})</span>
        <span class="fontStyle2" />
        <span class="fontStyle1">{{ basicinfo.deviceTypeT }}</span><!--设备类型-->
        <span class="fontStyle2" />
        <!--设备型号-->
        <!-- <span class="fontStyle1">{{ basicinfo.machineModel }}</span>
        <span class="fontStyle2" /> -->
        <span class="fontStyle1">{{ $t("yhubReport.FirmwareVersion") }}: V{{ basicinfo.fwVersion }}</span><!--固件-->
      </div>
    </el-row>
    <el-row class="content">
      <!-- 时间 -->
      <el-col :xs="24" :sm="24" :lg="24" class="card-panel-col">
        <p class="contentTitle">
          <i class="el-icon-time" style="font-size: 24px;vertical-align: top; margin-top: -5px;" />
          <span style="vertical-align: text-bottom;"> {{ timeAgo }}</span>
        </p>
        <dcdcDetailSetTem style="padding-bottom:20px;" />
      </el-col>
      <!-- 警告、dcdc -->
      <div class="dcChargeWarp">
        <el-col :xs="12" :sm="12" :lg="12" class="card-panel-col" style="height:1px;">
          <!-- 警告 -->
          <div v-if="isShowWarning" class="warningWarp">
            <div v-for="(item,index) in readyWarning" :key="index" style="margin-bottom: 10px;">
              <div class="warningImgAndP">
                <img :src="item.imgUrl">
                <span>{{ item.question }}</span>
              </div>
              <div class="warningP">
                <span>{{ item.answer }}</span>
              </div>
            </div>
            <!-- <div class="warningImgAndP">
              <img :src="warningImg.imgUrl">
              <span>{{ question }}</span>
            </div>
            <div class="warningP">
              <span>{{ answer }}</span>
            </div> -->
          </div>
        </el-col>
        <el-col :xs="12" :sm="12" :lg="12" class="card-panel-col">
          <div class="dcChargeDiv">
            <p v-if="dcdcData.machineModel" style="margin-bottom: 10px;text-align: center;width: 150px;">{{ dcdcData.machineModel }}</p>
            <img v-if="isAllOn" src="@/assets/images/dcCharge_online.png" alt="" class="dcChargeImg">
            <img v-if="!isAllOn" src="@/assets/images/dcCharge_offline.png" alt="" class="dcChargeImg">
            <div class="temInfo">
              <img src="@/assets/images/tem_black.png" alt="" style="height: 40px;">
              <span>{{ dcdcData.dcChargeTem }}℃</span>
            </div>
            <img v-if="isShowWarning" src="@/assets/images/warningIcon.png" alt="" class="warningIcon">
            <div class="dcChargeInfo">
              <div>CH3</div>
              <div>CH2</div>
              <div>CH1</div>
            </div>
          </div>
        </el-col>
      </div>
    </el-row>
    <!-- 中间箭头区 -->
    <el-row>
      <div class="arrowWarp">
        <!-- 左箭头 -->
        <div class="arrowBlock">
          <div v-if="isAllOn&&dcdcData.startBatteryV&&dcdcData.startBatteryV!='--'" class="greenDeltaTop greenDeltaArrowLft" />
          <div class="leftArrow1" :class="{'dottedLineLeft1':!isAllOn||(isAllOn&&(!dcdcData.startBatteryV||dcdcData.startBatteryV=='--'))}" />
          <div class="leftArrow2" :class="{'dottedLineLeft2':!isAllOn||(isAllOn&&(!dcdcData.startBatteryV||dcdcData.startBatteryV=='--'))}">
            <!-- 如果太阳能板的电压有，则不显示 -->
            <div v-if="(isAllOn&&(!dcdcData.solarPanelsV||dcdcData.solarPanelsV=='--'))||!isAllOn" class="machineVorA">
              <img src="@/assets/images/battery/aBlack.png" alt="">
              <span>{{ dcdcData.startBatteryA }} A</span>
            </div>
          </div>
          <div class="leftArrow3" :class="{'dottedLineLeft3':!isAllOn||(isAllOn&&(!dcdcData.startBatteryV||dcdcData.startBatteryV=='--'))}" />
        </div>
        <!-- 中间箭头 -->
        <div class="arrowBlock">
          <div v-if="isAllOn&&dcdcData.solarPanelsV&&dcdcData.solarPanelsV!='--'" class="greenDeltaTop greenDeltaArrowMiddle" />
          <!-- 虚线：1.不在线；2.没数据 -->
          <div class="middleArrow1" :class="{'dottedLineMiddle1':!isAllOn||(isAllOn&&(!dcdcData.solarPanelsV||dcdcData.solarPanelsV=='--'))}" />
          <div class="middleArrow2" :class="{'dottedLineMiddle2':!isAllOn||(isAllOn&&(!dcdcData.solarPanelsV||dcdcData.solarPanelsV=='--'))}">
            <!-- 如果太阳能板的电压无，则不显示 -->
            <div v-if="isAllOn&&dcdcData.solarPanelsV&&(dcdcData.solarPanelsV!='--')" class="machineVorA">
              <img src="@/assets/images/battery/aBlack.png" alt="">
              <span>{{ dcdcData.solarPanelsA }} A</span>
            </div>
          </div>
          <div class="middleArrow3" :class="{'dottedLineMiddle3':!isAllOn||(isAllOn&&(!dcdcData.solarPanelsV||dcdcData.solarPanelsV=='--'))}" />
        </div>
        <!-- 右箭头 -->
        <div class="arrowBlock">
          <div v-if="isAllOn&&isCellTeamOn" class="greenDeltaBottom greenDeltaArrowRight" />
          <div class="rightArrow1" :class="{'dottedLineRight1':!isAllOn||(isAllOn&&!isCellTeamOn)}" />
          <div class="rightArrow2" :class="{'dottedLineRight2':!isAllOn||(isAllOn&&!isCellTeamOn)}">
            <div class="machineVorA">
              <img src="@/assets/images/battery/aBlack.png" alt="">
              <span>{{ dcdcData.cellTeamA }} A</span>
            </div>
          </div>
          <div class="rightArrow3" :class="{'dottedLineRight3':!isAllOn||(isAllOn&&!isCellTeamOn)}" />
        </div>

      </div>
    </el-row>
    <!-- 下面图片区 -->
    <el-row>
      <div class="middleContentWarp">
        <!-- 启动电池 -->
        <div class="middleContentBox startBatteryWarp">
          <div class="blockDiv startBatteryInfo">
            <p>12V or 24v</p>
            <P>Start Battery</P>
          </div>
          <div class="blockDiv">
            <div class="startBatteryImg">
              <img v-if="isAllOn&&dcdcData.startBatteryV&&dcdcData.startBatteryV!='--'" src="@/assets/images/startBattery_online.png" alt="">
              <img v-else src="@/assets/images/startBattery_offline.png" alt="">
            <!-- <img v-if="!isCharging||!isAllOn" src="@/assets/images/startBattery_offline.png" alt=""> -->
            </div>
            <div class="machineVorA">
              <img src="@/assets/images/battery/vBlack.png" alt="">
              <span>{{ dcdcData.startBatteryV }} V</span>
            </div>
          </div>
        </div>
        <!-- 太阳能板 -->
        <div class="middleContentBox solarPanelsWarp">
          <div class="blockDiv">
            <div class="solarPanelsImg">
              <img v-if="isAllOn&&dcdcData.solarPanelsV&&dcdcData.solarPanelsV!='--'" src="@/assets/images/solarPanels_online.png" alt="">
              <img v-else src="@/assets/images/solarPanels_offline.png" alt="">
            </div>
            <div class="machineVorA">
              <img src="@/assets/images/battery/vBlack.png" alt="">
              <span>{{ dcdcData.solarPanelsV }} V</span>
            </div>
          </div>
          <div class="blockDiv solarPanelsInfo">
            <p>PV INPUT</p>
            <P>Non-regulated fixed or folding solar panels</P>
          </div>
        </div>
        <!-- 电池组 -->
        <div class="middleContentBox cellTeamWarp">
          <div class="blockDiv cellTeamInfo">
            <p>DC OUTPUT</p>
            <P>to Battery Bank</P>
            <P>(Grounded)</P>
          </div>
          <div class="blockDiv cellTeamInfoAndImg">
            <div class="cellTeamImg">
              <img v-if="isAllOn&&isCellTeamOn" src="@/assets/images/cellTeam_online.png" alt="">
              <img v-else src="@/assets/images/cellTeam_offline.png" alt="">
            </div>
            <div class="machineVorA">
              <img src="@/assets/images/battery/vBlack.png" alt="">
              <span>{{ dcdcData.cellTeamV }} V</span>
            </div>
            <div class="machineVorA">
              <img src="@/assets/images/tem_black.png" alt="" style="height: 30px;width: auto;">
              <span>{{ dcdcData.cellTeamTem }} ℃</span>
            </div>
          </div>
        </div>
      </div>
    </el-row>
  </div>
</template>

<script>

import { findDeviceInfo, setDMTCfg, getDMTCfg } from '@/api/bidirectional'
import { GetRealTimeData } from '@/api/leaseManagement'
import dcdcDetailSetTem from '@/views/dcdc/dcdcDetailSetTem'

import { howLongAgo } from '@/utils/updateTime.js'
import i18n from '@/i18n'

export default {
  name: 'Bidirectional',
  components: {
    dcdcDetailSetTem
  },
  data() {
    return {
      basicinfo: {},
      isAllOn: false, // 是否在线
      isStartBatteryOn: false, // 启动电池是否在线
      isSolarPanelsOn: false, // 太阳能板是否在线
      isCellTeamOn: true,

      isCharging: false,
      yhubmqtt: {}, // MQTT值
      dcdcMqttData: {}, // 来自MQTT的dcdc的值
      dcdcData: {// 双向逆变器数据
        dcChargeTem: '--',
        startBatteryA: '--',
        startBatteryV: '--',
        solarPanelsA: '--',
        solarPanelsV: '--',
        cellTeamA: '--',
        cellTeamV: '--',
        cellTeamTem: '--'
      },
      isShowWarning: false,
      readyWarning: [],
      question: '', // 警告--wenti
      answer: '', // 警告--答案
      warningInfo: [// 警告文字
        { key: 'E01', question: 'CH3 High Input Voltage Shutdown. This means the unit has detected the input from the Start/Alternator has gone above 16.0V on a 12V input or 32.0V on a 24V input. This error will clear once the input has dropped below 15.5V on a 12V input or 31.0V on a 24V input.', answer: '' },
        { key: 'E02', question: 'CH3 Low Input Voltage Shutdown. This means the unit has detected that the input from the Start/Alternator has gone below 10.5V on a 12V input or 21.0V on a 24V input. This error will clear once the input has risen above 13.2V on a 12V input or 26.4V on a 24V input.', answer: '• Check that the voltage of your Start Battery is above 13.2V on a 12V input or 26.4V on a 24V input.• Check that you have not left the “Priority” (Override) feature activated (Manual or Auto)• Check that the battery cable from the Start Battery is correctly sized.• Check you don’t have a loose terminal or blown fuse.' },
        { key: 'E03', question: 'CH2 High Input Voltage Shutdown. This means the unit has detected the input from the solar has gone above 45.0V. This error will clear once the input has dropped below 44.0V.', answer: '• Check the specification of your panels – the Volts Open Circuit (VOC) should not exceed 45VOC• Make sure the solar panels have not been connected in series as this will increase the VOC voltage of the panel array.Please Note: Maximum solar VOC input must not exceed 45VOC or damage to the unit will occur.' },
        { key: 'E04', question: 'CH2 Low Input Voltage Shutdown. This means the unit has detected the input from the Solar Array cannot sustain voltage above 14.5v.', answer: 'If you have this error:• Check that you are not in a low light/non direct sunlight situation i.e. Early morning / late afternoon.• This may also happen if your solar panels are inside in a shed with a skylight or Hi Bay Lights running or outside underFlood Lights.If you find this is happening with your unit when stored, we recommend fitting a DC Breaker to the output of the DC2DC+and turning it off when the unit is not in use/storage.' },
        { key: 'E05', question: 'CH1 High Input Voltage Shutdown.This means the unit has detected that the Main/House battery has gone above 16.0V. This error will clear once the input has dropped below 15.5V.This may be due to charging from another source. i.e. Another solar controller or AC battery charger.', answer: '' },
        { key: 'E06', question: 'Over Temperature Shutdown. When the charger senses the environmental temperature above 60°C, the charger will Shut down. It will recover automatically when the environmental temperature drops below 45°C. • Check to make sure the fan is working. • Make sure the unit has good ventilation.', answer: '' },
        { key: 'E07', question: 'BTS Over Temperature Shutdown. This means the units Battery Temp Sensor has detected that the batteries are too hot and has shut down to not over charge the batteries.', answer: 'If this occurs, take care and check the temperature of the batteries.• If the Batteries are Hot –you may have a dropped cell or faulty battery. Stop all charging and see your local batteryshop to get your batteries tested.• If the Batteries/Terminals are still cool or only warm, you may have a bad temp sensor. Unplug the temp sensor and call Enerdrive.' },
        { key: 'E08', question: 'CH1 Output Short Circuit. This means there is a Short Circuit on the DC output to your Main/House battery.', answer: 'If this is displayed, check the following:• The output wires are not shorted together.• The output wires are wired correctly and not reverse polarity.' }
      ],
      timeAgo: '',
      timeAgoRST: '',
      timer: null,
      // /////配置
      viewTable: false, // 表格--查看
      editTable: false, // 表格--编辑
      viewBtn: 'open', // 查看/收起配置--按钮
      editBtn: false, // 编辑--按钮
      closeBtn: false, // 取消--按钮
      tableDataAll: [
        { key: 'type', isShow: true, name: 'Model', nameZ: '型号', value: '', remark: '' },
        { key: 'batteryType', isShow: true, name: 'Battery Type', nameZ: '电池类型', value: '', remark: 'GEL, AGM, FLd, LI, PGM, PSY.' },
        { key: 'GAFA', isShow: true, name: 'Bulk Current / Float Current', nameZ: 'GEL/AGM/FloodedBulk /Float ', value: '', remark: 'GEL/AGM/Flooded Series Battery' },
        { key: 'GAFCharge', isShow: true, name: 'Charge Mode', nameZ: 'GEL/AGM/Flooded充电阶段', value: '', remark: '' },
        { key: 'GAFTem', isShow: true, name: 'Temp Mode', nameZ: 'GEL/AGM/Flooded温度补偿', value: '', remark: '' },
        { key: 'proABSV', isShow: true, name: 'Program & Bulk Voltage', nameZ: 'Program-ABS电压', value: '', remark: '' },
        { key: 'proV', isShow: true, name: 'Program & Float Voltage', nameZ: 'Program-Float电压', value: '', remark: '' },
        { key: 'proA', isShow: true, name: 'Bulk Current / Float Current', nameZ: 'ProgramBulk /Float ', value: '', remark: 'Program Series Battery' },
        { key: 'proCharge', isShow: true, name: 'Program & Charge Mode', nameZ: 'Program 充电阶段', value: '', remark: '' },
        { key: 'LithiumV', isShow: true, name: 'Lithium & Bulk Voltage', nameZ: 'Lithium电压 1~8', value: '', remark: '' },
        { key: 'LithiumFloatV', isShow: true, name: 'Lithium & Float Voltage', nameZ: '锂电浮充电压', value: '', remark: '' },
        { key: 'LithiumA', isShow: true, name: 'Bulk Current / Float Current', nameZ: 'LithiumBulk /Float ', value: '', remark: 'Lithium Series Battery' },
        { key: 'eqStatus', isShow: true, name: 'EQ Status', nameZ: 'EQ 状态', value: '', remark: '' },
        { key: 'autoStatus', isShow: true, name: 'Fan Quiet Mode', nameZ: 'Auto 状态', value: '', remark: '' }
      ],
      tableEditObj: {
        esc_I: [],
        proA: [],
        LithiumA: [],
        GAFCharge: '',
        GAFTem: '',
        proABSV: '',
        proV: '',
        proCharge: '',
        LithiumV: '',
        eqStatus: '',
        autoStatus: ''
      },
      tableEditObjBatteryType: null,
      tableEditObjType: null,
      typeOptions: [
        { label: 'DMT2430', value: '1' },
        { label: 'DMT1230', value: '2' },
        { label: 'DMT4810', value: '3' },
        { label: 'DMT1250', value: '4' }
      ],
      // typeOptions: [
      //   { label: 'DMT2430-EP', value: '1' },
      //   { label: 'DMT1230-EP', value: '2' },
      //   { label: 'DMT1230', value: '3' },
      //   { label: 'DMT2430', value: '4' },
      //   { label: 'DMT2430-EP', value: '5' },
      //   { label: 'DMT4810', value: '6' },
      //   { label: 'DMT4810-SE', value: '7' },
      //   { label: 'DMT1250', value: '8' },
      //   { label: 'DMT1250-EP', value: '9' }
      // ],
      batteryTypeOptions: [
        { label: 'GEL', value: '1' },
        { label: 'AGM', value: '2' },
        { label: 'Flooded', value: '3' },
        { label: 'Lithium', value: '4' },
        { label: 'Program', value: '5' }
      ],
      GAFAOptions: [],
      proABSVOptions: [],
      proVOptions: [],
      LithiumVOptions: [],
      LithiumFloatVOptions: [],
      // proABSVOptions: [
      //   { label: '13.8 V', value: '1' },
      //   { label: '13.9 V', value: '2' },
      //   { label: '14.0 V', value: '3' },
      //   { label: '14.1 V', value: '4' },
      //   { label: '14.2 V', value: '5' },
      //   { label: '14.3 V', value: '6' },
      //   { label: '14.4 V', value: '7' },
      //   { label: '14.5 V', value: '8' },
      //   { label: '14.6 V', value: '9' },
      //   { label: '14.7 V', value: '10' },
      //   { label: '14.8 V', value: '11' }
      // ],
      // proVOptions: [
      //   { label: '13.0 V', value: '1' },
      //   { label: '13.1 V', value: '2' },
      //   { label: '13.2 V', value: '3' },
      //   { label: '13.3 V', value: '4' },
      //   { label: '13.4 V', value: '5' },
      //   { label: '13.5 V', value: '6' },
      //   { label: '13.6 V', value: '7' },
      //   { label: '13.7 V', value: '8' },
      //   { label: '13.8 V', value: '9' }
      // ],
      // LithiumVOptions: [
      //   { label: '13.9 V', value: '1' },
      //   { label: '14.0 V', value: '2' },
      //   { label: '14.1 V', value: '3' },
      //   { label: '14.2 V', value: '4' },
      //   { label: '14.3 V', value: '5' },
      //   { label: '14.4 V', value: '6' },
      //   { label: '14.5 V', value: '7' },
      //   { label: '14.6 V', value: '8' }
      // ],
      // LithiumFloatVOptions: [
      //   { label: '13.0 V', value: '1' },
      //   { label: '13.1 V', value: '2' },
      //   { label: '13.2 V', value: '3' },
      //   { label: '13.3 V', value: '4' },
      //   { label: '13.4 V', value: '5' },
      //   { label: '13.5 V', value: '6' },
      //   { label: '13.6 V', value: '7' },
      //   { label: '13.7 V', value: '8' }
      // ],
      mGetCANCfgData: {},
      disabledEdit: true
    }
  },
  computed: {
    storeYhubmqtt() {
      return this.$store.state.yhubmqtt// 需要监听的数据
    },
    tableData: function() {
      return this.tableDataAll.filter(function(item) {
        return item.isShow
      })
    }
  },
  watch: {
    storeYhubmqtt: {
      handler(newValue, oldValue) {
        this.yhubmqtt = newValue // 把新值赋值给我们的属性数据
        // console.log(this.yhubmqtt)
        // console.log(this.yhubmqtt.payload)
        this.MQTT()
      },
      deep: true
    },
    tableEditObjType: {// 型号
      handler(newValue, oldValue) {
        console.log(newValue)
        if (newValue.indexOf('10') > -1) {
          this.GAFAOptions = [
            {
              value: '2',
              label: 'Bulk 5A',
              children: [
                { value: '1', label: 'Float 0.3A' },
                { value: '2', label: 'Float 0.5A' },
                { value: '3', label: 'Float 1A' }
              ]
            },
            {
              value: '1',
              label: 'Bulk 10A',
              children: [
                { value: '1', label: 'Float 0.5A' },
                { value: '2', label: 'Float 1A' },
                { value: '3', label: 'Float 2A' }
              ]
            }
          ]
        } else if (newValue.indexOf('30') > -1) {
          this.GAFAOptions = [
            {
              value: '1',
              label: 'Bulk 5A',
              children: [
                { value: '1', label: 'Float 0.3A' },
                { value: '2', label: 'Float 0.5A' },
                { value: '3', label: 'Float 1A' }
              ]
            },
            {
              value: '2',
              label: 'Bulk 10A',
              children: [
                { value: '1', label: 'Float 0.5A' },
                { value: '2', label: 'Float 1A' },
                { value: '3', label: 'Float 2A' }
              ]
            },
            {
              value: '3',
              label: 'Bulk 20A',
              children: [
                { value: '1', label: 'Float 1A' },
                { value: '2', label: 'Float 2A' },
                { value: '3', label: 'Float 4A' }
              ]
            },
            {
              value: '4',
              label: 'Bulk 30A',
              children: [
                { value: '1', label: 'Float 1.5A' },
                { value: '2', label: 'Float 3A' },
                { value: '3', label: 'Float 6A' }
              ]
            }
          ]
        } else if (newValue.indexOf('50') > -1) {
          this.GAFAOptions = [
            {
              value: '1',
              label: 'Bulk 5A',
              children: [
                { value: '1', label: 'Float 1A' },
                { value: '2', label: 'Float 1.5A' },
                { value: '3', label: 'Float 2A' }
              ]
            },
            {
              value: '2',
              label: 'Bulk 10A',
              children: [
                { value: '1', label: 'Float 1A' },
                { value: '2', label: 'Float 1.5A' },
                { value: '3', label: 'Float 2A' }
              ]
            },
            {
              value: '3',
              label: 'Bulk 15A',
              children: [
                { value: '1', label: 'Float 1A' },
                { value: '2', label: 'Float 1.5A' },
                { value: '3', label: 'Float 3A' }
              ]
            },
            {
              value: '4',
              label: 'Bulk 20A',
              children: [
                { value: '1', label: 'Float 2A' },
                { value: '2', label: 'Float 3A' },
                { value: '3', label: 'Float 4A' }
              ]
            },
            {
              value: '5',
              label: 'Bulk 25A',
              children: [
                { value: '1', label: 'Float 2A' },
                { value: '2', label: 'Float 4A' },
                { value: '3', label: 'Float 5A' }
              ]
            },
            {
              value: '6',
              label: 'Bulk 30A',
              children: [
                { value: '1', label: 'Float 3A' },
                { value: '2', label: 'Float 4A' },
                { value: '3', label: 'Float 6A' }
              ]
            },
            {
              value: '7',
              label: 'Bulk 35A',
              children: [
                { value: '1', label: 'Float 3A' },
                { value: '2', label: 'Float 5A' },
                { value: '3', label: 'Float 7A' }
              ]
            },
            {
              value: '8',
              label: 'Bulk 40A',
              children: [
                { value: '1', label: 'Float 4A' },
                { value: '2', label: 'Float 6A' },
                { value: '3', label: 'Float 8A' }
              ]
            },
            {
              value: '9',
              label: 'Bulk 45A',
              children: [
                { value: '1', label: 'Float 4A' },
                { value: '2', label: 'Float 6A' },
                { value: '3', label: 'Float 9A' }
              ]
            },
            {
              value: '10',
              label: 'Bulk 50A',
              children: [
                { value: '1', label: 'Float 5A' },
                { value: '2', label: 'Float 7A' },
                { value: '3', label: 'Float 10A' }
              ]
            }
          ]
        }
        if (newValue.indexOf('12') > -1) {
          this.proABSVOptions = [
            { label: '13.8 V', value: '1' },
            { label: '13.9 V', value: '2' },
            { label: '14.0 V', value: '3' },
            { label: '14.1 V', value: '4' },
            { label: '14.2 V', value: '5' },
            { label: '14.3 V', value: '6' },
            { label: '14.4 V', value: '7' },
            { label: '14.5 V', value: '8' },
            { label: '14.6 V', value: '9' },
            { label: '14.7 V', value: '10' },
            { label: '14.8 V', value: '11' }
          ]
          this.proVOptions = [
            { label: '13.0 V', value: '1' },
            { label: '13.1 V', value: '2' },
            { label: '13.2 V', value: '3' },
            { label: '13.3 V', value: '4' },
            { label: '13.4 V', value: '5' },
            { label: '13.5 V', value: '6' },
            { label: '13.6 V', value: '7' },
            { label: '13.7 V', value: '8' },
            { label: '13.8 V', value: '9' }
          ]
          this.LithiumVOptions = [
            { label: '13.9 V', value: '1' },
            { label: '14.0 V', value: '2' },
            { label: '14.1 V', value: '3' },
            { label: '14.2 V', value: '4' },
            { label: '14.3 V', value: '5' },
            { label: '14.4 V', value: '6' },
            { label: '14.5 V', value: '7' },
            { label: '14.6 V', value: '8' }
          ]
          this.LithiumFloatVOptions = [
            {	label: '13.5	V',	value: '1'	},
            {	label: '13.6	V',	value: '2'	},
            {	label: '13.7	V',	value: '3'	},
            {	label: '13.8	V',	value: '4'	},
            {	label: '13.9	V',	value: '5'	},
            {	label: '14.0	V',	value: '6'	},
            {	label: '14.1	V',	value: '7'	},
            {	label: '14.2	V',	value: '8'	}
          ]
        } else if (newValue.indexOf('24') > -1) {
          this.proABSVOptions = [
            { label: '27.6 V', value: '1' },
            { label: '27.8 V', value: '2' },
            { label: '28.0 V', value: '3' },
            { label: '28.2 V', value: '4' },
            { label: '28.4 V', value: '5' },
            { label: '28.6 V', value: '6' },
            { label: '28.8 V', value: '7' },
            { label: '29.0 V', value: '8' },
            { label: '29.2 V', value: '9' },
            { label: '29.4 V', value: '10' },
            { label: '29.6 V', value: '11' }
          ]
          this.proVOptions = [
            { label: '26.0 V', value: '1' },
            { label: '26.2 V', value: '2' },
            { label: '26.4 V', value: '3' },
            { label: '26.6 V', value: '4' },
            { label: '26.8 V', value: '5' },
            { label: '27.0 V', value: '6' },
            { label: '27.2 V', value: '7' },
            { label: '27.4 V', value: '8' },
            { label: '27.6 V', value: '9' }
          ]
          this.LithiumVOptions = [
            {	label: '27.8	V',	value: '1'	},
            {	label: '28.0	V',	value: '2'	},
            {	label: '28.2	V',	value: '3'	},
            {	label: '28.4	V',	value: '4'	},
            {	label: '28.6	V',	value: '5'	},
            {	label: '28.8	V',	value: '6'	},
            {	label: '29.0	V',	value: '7'	},
            {	label: '29.2	V',	value: '8'	}
          ]
          this.LithiumFloatVOptions = [
            {	label: '27.0	V',	value: '2'	},
            {	label: '27.2	V',	value: '3'	},
            {	label: '27.4	V',	value: '4'	},
            {	label: '27.6	V',	value: '5'	},
            {	label: '27.8	V',	value: '6'	},
            {	label: '28.0	V',	value: '7'	},
            {	label: '28.2	V',	value: '8'	}
          ]
        } else if (newValue.indexOf('48') > -1) {
          this.proABSVOptions = [
            { label: '55.2 V', value: '1' },
            { label: '55.6 V', value: '2' },
            { label: '56.0 V', value: '3' },
            { label: '56.4 V', value: '4' },
            { label: '56.8 V', value: '5' },
            { label: '57.2 V', value: '6' },
            { label: '57.6 V', value: '7' },
            { label: '58.0 V', value: '8' },
            { label: '58.4 V', value: '9' },
            { label: '58.8 V', value: '10' },
            { label: '59.2 V', value: '11' }
          ]
          this.proVOptions = [
            { label: '52.0 V', value: '1' },
            { label: '52.4 V', value: '2' },
            { label: '52.8 V', value: '3' },
            { label: '53.2 V', value: '4' },
            { label: '53.6 V', value: '5' },
            { label: '54.0 V', value: '6' },
            { label: '54.4 V', value: '7' },
            { label: '54.8 V', value: '8' },
            { label: '55.2 V', value: '9' }
          ]
          this.LithiumVOptions = [
            {	label: '55.6	V',	value: '1'	},
            {	label: '56.0	V',	value: '2'	},
            {	label: '56.4	V',	value: '3'	},
            {	label: '56.8	V',	value: '4'	},
            {	label: '57.2	V',	value: '5'	},
            {	label: '57.6	V',	value: '6'	},
            {	label: '58.0	V',	value: '7'	},
            {	label: '58.4	V',	value: '8'	}

          ]
          this.LithiumFloatVOptions = [
            {	label: '54.0	V',	value: '1'	},
            {	label: '54.4	V',	value: '2'	},
            {	label: '54.8	V',	value: '3'	},
            {	label: '55.2	V',	value: '4'	},
            {	label: '55.6	V',	value: '5'	},
            {	label: '56.0	V',	value: '6'	},
            {	label: '56.4	V',	value: '7'	},
            {	label: '56.8	V',	value: '8'	}
          ]
        }
      },
      deep: true
    },
    tableEditObjBatteryType: {
      handler(newValue, oldValue) {
        console.log(newValue)
        this.tableDataAll.forEach(v => {
          if (newValue == 1 || newValue == 2 || newValue == 3) { // GEL/AGM/Flooded
            if (v.key == 'GAFA' || v.key == 'GAFCharge' || v.key == 'GAFTem') { v.isShow = true } else { v.isShow = false }
          } else if (newValue == 4) { // Lithium
            if (v.key == 'LithiumV' || v.key == 'LithiumFloatV' || v.key == 'LithiumA') { v.isShow = true } else { v.isShow = false }
          } else if (newValue == 5) { // Program
            if (v.key == 'proABSV' || v.key == 'proV' || v.key == 'proA' || v.key == 'proCharge') { v.isShow = true } else { v.isShow = false }
          }
          if (v.key == 'type' || v.key == 'batteryType' || v.key == 'eqStatus' || v.key == 'autoStatus') { v.isShow = true }
        })
        // console.log(this.yhubmqtt.payload)
      },
      deep: true
    }
  },
  mounted() {
    this.queryList()
    GetRealTimeData({ mcuId: this.$route.query.mcuId }).then(res => {})
    getDMTCfg({ mcuId: this.$route.query.mcuId }).then(res => {})
    // this.tableEditObj.esc_I = ['1', '2']
    // this.tableEditObj.proCharge = '1'
    // this.tableEditObjType = 'DMT1230'
    // this.tableEditObjBatteryType = '3'
  },
  created() {
    // 每次进入界面时，先清除之前的所有定时器，然后启动新的定时器
    clearInterval(this.timer)
    this.timer = null
    this.setTimer()
  },
  destroyed: function() {
    // 每次离开当前界面时，清除定时器
    clearInterval(this.timer)
    this.timer = null
    this.setTimer()
  },
  methods: {
    queryList() {
      var param = {
        'mcuId': this.$route.query.mcuId
      }
      // 设备信息
      findDeviceInfo(param).then(res => {
        // 设备信息详情
        this.basicinfo = res.resultModel
        this.basicinfo.deviceTypeT = this.$route.query.deviceTypeT
      })
    },
    // clickSet() {
    //   this.viewTable = !this.viewTable
    //   if (this.editTable) {
    //     this.viewTable = false
    //     this.editTable = false
    //   }
    // },
    clickSet(val) {
      if (val == 'close') { // 收起
        this.viewTable = this.editTable = this.editBtn = false
        this.viewBtn = 'open'
      } else { // 查看
        this.editBtn = this.viewTable = true
        this.viewBtn = 'close'
      }
    },
    edit() {
      this.viewBtn = ''
      this.editTable = this.closeBtn = true
      this.viewTable = this.editBtn = false
    },
    close() {
      this.editTable = this.closeBtn = false
      this.viewBtn = 'close'
      this.viewTable = this.editBtn = true
    },
    tableSubmit() {
      var param = {
        'mcuId': this.$route.query.mcuId,
        'bat_type': this.tableEditObjBatteryType,
        // 'chargeStage': this.tableEditObj.GAFCharge,
        // 'tempCompensation': this.tableEditObj.GAFTem,
        // 'programAbs_V': this.tableEditObj.proABSV,
        // 'programFloat_V': this.tableEditObj.proV,
        // 'programChargeStage': this.tableEditObj.proCharge,
        // 'lithium_V': this.tableEditObj.LithiumV,
        // 'LithiumFloat_V': this.tableEditObj.LithiumFloatV,
        'EQStatus': this.tableEditObj.eqStatus,
        'autoStatus': this.tableEditObj.autoStatus,
        'model': this.tableEditObjType
        // 'charge_I': this.tableEditObj.esc_I[0],
        // 'esc_I': this.tableEditObj.esc_I[1],
        // 'programCharge_I': this.tableEditObj.proA[0],
        // 'programEsc_I': this.tableEditObj.proA[1],
        // 'lithiumCharge_I': this.tableEditObj.LithiumA[0],
        // 'lithiumEsc_I': this.tableEditObj.LithiumA[1],
      }
      if (this.tableEditObj.GAFCharge)param.chargeStage = this.tableEditObj.GAFCharge
      if (this.tableEditObj.GAFTem)param.tempCompensation = this.tableEditObj.GAFTem
      if (this.tableEditObj.proABSV)param.programAbs_V = this.tableEditObj.proABSV
      if (this.tableEditObj.proV)param.programFloat_V = this.tableEditObj.proV
      if (this.tableEditObj.proCharge)param.programChargeStage = this.tableEditObj.proCharge
      if (this.tableEditObj.LithiumV)param.lithium_V = this.tableEditObj.LithiumV
      if (this.tableEditObj.LithiumFloatV)param.LithiumFloat_V = this.tableEditObj.LithiumFloatV
      if (this.tableEditObj.esc_I) {
        param.charge_I = this.tableEditObj.esc_I[0]
        param.esc_I = this.tableEditObj.esc_I[1]
      }
      if (this.tableEditObj.proA) {
        param.programCharge_I = this.tableEditObj.proA[0]
        param.programEsc_I = this.tableEditObj.proA[1]
      }
      if (this.tableEditObj.LithiumA) {
        param.lithiumCharge_I = this.tableEditObj.LithiumA[0]
        param.lithiumEsc_I = this.tableEditObj.LithiumA[1]
      }
      if (this.tableEditObjType) {
        var str = this.tableEditObjType.indexOf('-') > -1 ? this.tableEditObjType.split('-')[0] : this.tableEditObjType
        param.model = str.slice(3)
      }
      this.$confirm(i18n.t('basicinfo.submitChange'), '', {// '是否提交修改？'
        confirmButtonText: i18n.t('button.Confirm'), // '确定',
        cancelButtonText: i18n.t('button.Cancel'),
        type: 'warning'
      }).then(() => {
        setDMTCfg(param).then(res => {
          if (res.code == 200) {
            this.$message({
              type: 'success',
              message: i18n.t('warningSet.submitted')
            })
            this.viewTable = this.editBtn = true
            this.editTable = this.closeBtn = false
            this.viewBtn = 'close'
          }
        })
      }).catch(() => {
      })
    },
    MQTT() {
      if (this.yhubmqtt) {
        // console.log('yhubmqtt-----', this.yhubmqtt)
        // this.$route.query.mcuId = '05d6ff393430475043165127'
        if (!this.yhubmqtt.topic || this.yhubmqtt.topic.indexOf(this.$route.query.mcuId) == -1) return
        if (this.yhubmqtt.payload === 'mCan') {
          // console.log('this.yhubmqtt---', this.yhubmqtt.mCan)
          var mCanData = this.yhubmqtt.mCan
          // console.log('mCanData.payload---', mCanData.payload)
          // if (!mCanData) return
          if (mCanData && mCanData.payload === 'mDMTRealTimeData') {
            this.dcdcMqttData = mCanData.mDMTRealTimeData // 实时详情、警告
            console.log('this.mDMTRealTimeData---', this.dcdcMqttData)
            if (!this.dcdcMqttData) return
            if (this.dcdcMqttData) {
              this.timeAgo = i18n.t('dataAndTime.AMomentAgo')
              this.timeAgoRST = new Date().getTime()
              if (this.dcdcMqttData.connection === 1) { // 设备状态 1：连接 0：断开
                this.isAllOn = true
              } else {
                this.isAllOn = false
              }
              this.dcdcData.machineModel = this.dcdcMqttData.modeName.toString(16)
              if (this.dcdcMqttData.modeName) this.tableEditObjType = 'DMT' + this.dcdcMqttData.modeName.toString(16)
              if (!this.dcdcMqttData.batInput_V && !this.dcdcMqttData.pvInput_V) { this.isCellTeamOn = false } else { this.isCellTeamOn = true }
              this.dcdcData.dcChargeTem = this.dcdcMqttData.deviceTemperature > 10000 ? -Math.round((this.dcdcMqttData.deviceTemperature - 10000) / 10) : Math.round(this.dcdcMqttData.deviceTemperature / 10)
              this.dcdcData.startBatteryA = this.dcdcMqttData.input_I / 100
              this.dcdcData.startBatteryV = this.dcdcMqttData.batInput_V / 100
              this.dcdcData.solarPanelsA = this.dcdcMqttData.input_I / 100
              this.dcdcData.solarPanelsV = this.dcdcMqttData.pvInput_V / 100
              if (this.isCellTeamOn) {
                this.dcdcData.cellTeamA = this.dcdcMqttData.output_I / 100
                this.dcdcData.cellTeamV = this.dcdcMqttData.output_V / 100
                this.dcdcData.cellTeamTem = this.dcdcMqttData.batteryTemperature > 100 ? -Math.round((this.dcdcMqttData.batteryTemperature - 10000) / 10) : Math.round(this.dcdcMqttData.batteryTemperature / 10)
              }
              this.readyWarning = []
              var errors = []
              if (this.dcdcMqttData.errorStatus) { // 警告
                this.isShowWarning = true
                errors = this.decimalToBinary(this.dcdcMqttData.errorStatus)
                // console.log('errors----------', errors)
                errors.forEach((v, i) => {
                  if (v == 1) {
                    var ii = i + 1
                    this.readyWarning.push({
                      imgUrl: require('@/assets/images/warningSimpleImg/E0' + ii + '.png'),
                      question: this.warningInfo[i].question,
                      answer: this.warningInfo[i].answer
                    })
                  }
                })
              } else {
                this.isShowWarning = false
              }
            }
          }
        }
      }
    },
    change(e) {
      this.$forceUpdate()
    },
    setTimer() { // 定时器
      if (this.timer == null) {
        this.timer = setInterval(() => {
          if (this.timeAgoRST) { this.timeAgo = howLongAgo(this.timeAgoRST) }
        }, 600)
      }
    },
    getBit(n, k) {
      var bx = false
      if (((n >> k) & 1) == 1) {
        bx = true
      } else {
        bx = false
      }
      return bx
    },
    decimalToBinary(num) { // 十进制转二进制
      var myNum = num
      var b = []
      while (1) {
        var remainder = num % 2
        b.unshift(remainder)
        num = parseInt(num / 2)
        if (num == 0) break
      }
      var len
      if (myNum < 10) {
        len = 4 - b.length
        for (var i = 0; i < len; i++) {
          b.unshift(0)
        }
      } else if (myNum >= 10 && myNum < 100) {
        len = 8 - b.length
        for (var j = 0; j < len; j++) {
          b.unshift(0)
        }
      }
      return b.reverse()
    }
  }
}
</script>

<style lang="scss" scoped>
p{
  margin:0
}
.card-panel{
  padding-bottom: 20px;
}
#dcdcDetail{
  .content{
    background:white;
    margin-top: 32px;
    padding: 20px;
  }
  .blockDiv{
    display: inline-block;
  }
  .machineVorA{
    text-align: center;
  }
  .machineVorA img{
    width:30px;
  }
  .machineVorA span{
    line-height: 30px;
    vertical-align: top;
  }
  .middleContentWarp{
    background:white;
    display: flex;
    justify-content: space-around;
    align-items: center;
    height: 100%;
    padding: 0 5%;
    height: 180px;
    padding-bottom: 10px;
    // border:1px solid red;
  }
  .middleContentBox{
    display: inline-block;
    // border:1px solid red;
  }

  .warningWarp{
    padding: 0px 5%;
    display: inline-block;
    width:90%;
    max-height: 250px;
    overflow-y: auto;
  }
  .warningWarp img{
    width: 50px;
  }
  .warningWarp .warningImgAndP{
    display: flex;
    align-items: center;
  }
  .warningWarp .warningImgAndP span{
    margin-left: 10px;
    color: red;
  }
  .warningWarp .warningP{
    margin-top: 5px;
    color: blue;
  }
  .dcChargeWarp{
    padding:0 5%;
  }
  .dcChargeDiv{
    position: relative;
  }
  .dcChargeImg{
    width:150px;
    // border:1px solid red;
  }
  .warningIcon{
    width: 20px!important;
    position:absolute;
    top: -5px;
    left: -10px;
  }
  .temInfo{
    display: flex;
    align-items: center;
    position: absolute;
    top: 80px;
    left: 180px;
  }
  .dcChargeInfo{
    display: flex;
    width: 150px;
    justify-content: space-around;
    padding: 0 10px;
  }
  .startBatteryImg img{
    width: 150px;
  }
  .startBatteryInfo{
    vertical-align: top;
    margin-top: 20px;
    // border:1px solid red;
  }
  .solarPanelsImg img{
    width:180px;
    margin-top: 10px;
  }
  .solarPanelsInfo,.cellTeamInfo{
    vertical-align: bottom;
    max-width: 140px;
    margin-bottom: 35px;
    margin-left: 5px;
    text-align: right;
  }
  .solarPanelsInfo p:nth-child(n+2),.cellTeamInfo p:nth-child(n+2){
    color:#8c8b8b;
  }
  .solarPanelsInfo p:nth-of-type(1){
    text-align: left;
  }
  .solarPanelsInfo p:nth-of-type(1),.cellTeamInfo p:nth-of-type(1){
    font-size: 20px;
  }
  .solarPanelsInfo p:nth-of-type(2){
    margin-left: -20px;
    // text-align: right;
  }
  .machineVorA{
    text-align: center;
  }
  .machineVorA img{
    width:30px;
  }
  .machineVorA span{
    line-height: 30px;
    vertical-align: top;
  }
  .cellTeamImg img{
    width:180px;
  }
  .arrowWarp{
    background:white;
    width:100%;
    height:120px;
    // border:1px solid red;
    padding:0 5%;
  }
  .arrowBlock{
    position: relative;
  }
  .arrowBlock div{
    position: absolute;
  }
  .greenDeltaTop{//向上三角形
    width: 0;
    height: 0;
    border-bottom: 15px solid #63bb38;
    border-left: 10px solid transparent;
    border-right: 10px solid transparent;
    position: absolute;
  }
  .greenDeltaBottom{//向下三角形
    width: 0;
    height: 0;
    border-top: 15px solid #63bb38;
    border-left: 10px solid transparent;
    border-right: 10px solid transparent;
    position: absolute;
  }
  .greenDeltaArrowLft{
    left: calc(50% + 22px);
    top: -15px;
  }
  .leftArrow1,.dottedLineLeft1{
    width: 3px;
    height: 80px;
    border-left: 3px solid #63bb38;
    left: calc(15% + 45px);
    top: 40px;
  }
  .leftArrow2{
    width: calc(35% - 14px);
    height: 3px;
    border-top: 3px solid #63bb38;
    left: calc(15% + 45px);
    top: 40px;
  }
  .leftArrow3{
    width: 3px;
    height: 43px;
    border-left: 3px solid #63bb38;
    left: calc(50% + 30px);
  }
  .dottedLineLeft1,.dottedLineLeft3{
   border-left: 3px dotted #e3e3e3;
  }
  .dottedLineLeft2{
   border-top: 3px dotted #e3e3e3;
  }
  .greenDeltaArrowMiddle{
    left: calc(50% + 66px);
    top: -15px;
  }
  .middleArrow1,.dottedLineMiddle1{
    width: 3px;
    height: 50px;
    border-left: 3px solid #63bb38;
    left: calc(45% - 40px);
    top: 80px;
  }
  .middleArrow2{
    width: calc(5% + 116px);
    height: 3px;
    border-top: 3px solid #63bb38;
    left: calc(45% - 40px);
    top: 80px;
  }
  .middleArrow3{
    width: 3px;
    height: 83px;
    border-left: 3px solid #63bb38;
    left: calc(50% + 74px);
  }
  .dottedLineMiddle1,.dottedLineMiddle3{
   border-left: 3px dotted #e3e3e3;
  }
  .dottedLineMiddle2{
   border-top: 3px dotted #e3e3e3;
  }
  .greenDeltaArrowRight{
    bottom: -120px;
    right: calc(15% - 49px);
  }
  .rightArrow1,.dottedLineRight1{
    width: 3px;
    height: 78px;
    border-left: 3px solid #63bb38;
    right: calc(15% - 40px);
    top: 40px;
  }
  .rightArrow2,.dottedLineRight2{
    width: calc(35% - 80px);
    height: 3px;
    border-top: 3px solid #63bb38;
    top: 40px;
    right: calc(15% - 40px);
  }
  .rightArrow3,.dottedLineRight3{
    width: 3px;
    height: 43px;
    // top: -13px;
    border-left: 3px solid #63bb38;
    right: calc(50% - 120px);
  }
  .dottedLineRight1,.dottedLineRight3{
   border-left: 3px dotted #e3e3e3;
  }
  .dottedLineRight2{
   border-top: 3px dotted #e3e3e3;
  }
  .leftArrow2,.middleArrow2,.rightArrow2{
    display: flex;
    justify-content: center;
  }
  .leftArrow2 .machineVorA, .middleArrow2 .machineVorA,.rightArrow2 .machineVorA{
    margin-top: -35px;
  }
  // .middleArrow2 .machineVorA{
  //   margin-top: 3px;
  // }
  .cellTeamInfoAndImg{
    text-align: center;
  }
  .cellTeamWarp .machineVorA{
    display: inline-block;
  }
  .cellTeamInfoAndImg div:nth-of-type(3){
    margin-left:5px;
  }
}
#dcdcDetail{
  .contentTitle{
    height:50px;
    line-height:50px;
    border-bottom: 2px solid #e6e9ed;
    font-weight: bold;
  }
}
</style>
<style lang="scss">
.contentWrap{
  .el-cascader-menu__wrap{
    height: calc(100% + 50px)!important;
  }
  .el-select,.el-cascader--medium {
    width: 80%;
  }
  .el-radio__input.is-disabled+span.el-radio__label {
    color: #969696;
  }
}
</style>

